import getWithToken from './base/get-with-token'

const getCustomerConsumptionBillingUsage = id => getWithToken(`/customer/${id}/billing-data`)

export default getCustomerConsumptionBillingUsage
